<section class="non-merchant-section">
  <h2>{{ nonMerchantSearchData?.heading }}</h2>
  <p [innerHTML]="nonMerchantSearchData?.desc | safeHtml"></p>

  <div class="tiles">
    @for (tile of nonMerchantSearchData?.tiles; track $index;let first = $first)
    { @if(first){
    <div class="address-bar-tile">
      @for (firstTile of tile; track $index) {
      <div>
        <img
          [lazyload]="csp.imagePrefix() + firstTile?.icon?.[device]"
          [cache]="csp.imagePrefix() + firstTile?.icon?.[device]"
          [alt]="firstTile?.adaText"
        />
        <p [innerHTML]="firstTile?.desc | safeHtml"></p>
      </div>
      }
    </div>

    } @else{
    <div class="search-tile">
      <img
        [lazyload]="csp.imagePrefix() + tile?.icon?.[device]"
        [cache]="csp.imagePrefix() + tile?.icon?.[device]"
        [alt]="tile?.adaText"
      />
      <p [innerHTML]="tile?.desc | safeHtml"></p>
    </div>
    } }
  </div>
</section>
